var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg58(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5039 46.4844L0.117183 2.91016C-0.23438 2.20703 0.292964 1.38672 1.05468 1.38672H8.45703C8.84765 1.38672 9.21875 1.62109 9.39453 1.95312L25.0195 33.5547C26.4062 36.3867 30.4492 36.3867 31.8359 33.5547L47.4023 1.97266C47.5781 1.62109 47.9492 1.40625 48.3398 1.40625H49.2578C49.8047 1.40625 50.1562 1.97266 49.9023 2.44141L28.3008 46.4844C26.9141 49.3164 22.8906 49.3164 21.5039 46.4844Z",
    fill: "url(#paint0_linear_2460_2691)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M21.5039 46.4844L9.41407 1.99219C9.23829 1.62109 8.84766 1.42578 8.51563 1.42578H1.07422C0.25391 1.42578 -0.21484 2.24609 0.0976595 2.94922L21.5039 46.4844Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.0195 33.5938L0.11719 2.91016C-0.175779 2.1875 0.27344 1.46484 0.957034 1.38672H8.4961C8.92578 1.40625 9.23828 1.67969 9.39453 1.95312L25.0195 33.5938Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2460_2691",
    x1: -0.00000462521,
    y1: 25,
    x2: 50,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D4ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#9055C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6B74D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#4C8FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#34A3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#22B2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#18BAFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#15BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28BAD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg58);
export default __webpack_public_path__ + "static/media/58.f24587beee738f6631446248319290e8.svg";
export { ForwardRef as ReactComponent };